<!-- <div class="modalHeader mt-5">
    <button mat-icon-button (click)="onClose()" class="modal-close-button closebtn btn-circle btn-close-custom" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
</div>
<div class="containt">   
  
</div> -->


<section>
    <div class="mainDiv">
        <div class="banner_content">
            <div class="whiteTitle">{{headerTitle}}</div>
            <div class="subMenu_content">
                <app-sub-menu></app-sub-menu>
            </div>
        </div>
        <div class="subContent">
            <button class="btn btn_back" routerLink="/locateus">Back To List</button>
            <div class="card_content mt-3">
                <iframe width="100%" height="1000" [src]="sourceurl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>            
        </div>
    </div>
</section>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<!-- Modal -->


